import { useEffect, useRef } from 'react';

const useOnUpdate = (handler, dependencies) => {
  const mounted = useRef(false);

  // Create a ref that stores handler.
  const savedHandler = useRef();

  // Update ref.current value if handler changes. This allows our effect below
  // to always get latest handler without us needing to pass it in effect
  // dependencies array and potentially cause effect to re-run every render.
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    if (mounted.current) {
      savedHandler.current();
    }

    mounted.current = true;
  }, dependencies);
};

export default useOnUpdate;
